module.exports = __webpack_public_path__ + "img/allow-blue-up.73e9a9fc.svg";